import { initializeApp } from "firebase/app";
import { browserLocalPersistence, connectAuthEmulator, getAuth, setPersistence } from "firebase/auth";
import { connectDatabaseEmulator, getDatabase } from "firebase/database";
import { connectStorageEmulator, getStorage } from "firebase/storage";

export const firebaseConfig = {
  apiKey: "AIzaSyChjw3Re4Q1KYp4pZ2XInlvC59j0FvM7Sc",
  authDomain: "mkb-leadmagnet.firebaseapp.com",
  databaseURL: "https://mkb-leadmagnet-default-rtdb.firebaseio.com",
  projectId: "mkb-leadmagnet",
  storageBucket: "mkb-leadmagnet.firebasestorage.app",
  messagingSenderId: "707845520991",
  appId: "1:707845520991:web:2607ebcee2c527a67fa5ea",
  measurementId: "G-720B7TMEBZ"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectDatabaseEmulator(database, "127.0.0.1", 9000);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}

export const authPersistenceReady = setPersistence(auth, browserLocalPersistence);
